export default __webpack_public_path__ + "static/media/login.b5702a61.jpg";